/**
 * aswbe reservation eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CartsUpdatePetRakunoriRequestServicesPetDetailInnerCageSize } from './cartsUpdatePetRakunoriRequestServicesPetDetailInnerCageSize';

/**
 * ケージサイズ情報
 */
export interface CartsUpdatePetRakunoriRequestServicesPetDetailInnerCage {
  /**
   * ペット種類
   */
  petType: string;
  /**
   * ケージ種類   carryOn: 持ち込み   lending: 貸出
   */
  cageType: CartsUpdatePetRakunoriRequestServicesPetDetailInnerCage.CageTypeEnum;
  /**
   * 貸出ケージの種類   ※ケージ種類が貸出の場合必須
   */
  lendingCageType?: CartsUpdatePetRakunoriRequestServicesPetDetailInnerCage.LendingCageTypeEnum;
  size?: CartsUpdatePetRakunoriRequestServicesPetDetailInnerCageSize;
  /**
   * 重量(kg)   ※ケージ種類が持ち込みの場合必須
   */
  weight: number;
}
export namespace CartsUpdatePetRakunoriRequestServicesPetDetailInnerCage {
  export type CageTypeEnum = 'carryOn' | 'lending';
  export const CageTypeEnum = {
    CarryOn: 'carryOn' as CageTypeEnum,
    Lending: 'lending' as CageTypeEnum,
  };
  export type LendingCageTypeEnum = 'S' | 'M' | 'L';
  export const LendingCageTypeEnum = {
    S: 'S' as LendingCageTypeEnum,
    M: 'M' as LendingCageTypeEnum,
    L: 'L' as LendingCageTypeEnum,
  };
}
